import React from 'react';
import styles from './css/index.module.scss';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';
import { SOUNDPROOFING_RANGE_KEYS } from '../../../../constants/soundproofing';

const SUFFIXES = {
  [SOUNDPROOFING_RANGE_KEYS.rw]: '',
  [SOUNDPROOFING_RANGE_KEYS.rwC]: '+C',
  [SOUNDPROOFING_RANGE_KEYS.rwCtr]: '+Ctr',
};

// Renders «Rw [dB]», «Rw+C [dB]» or «Rw+Ctr [dB]» with the subscript «w»
function RwLabel({ rangeKey, withUnit = true }) {
  const { t } = useTranslations();

  return (
    <>
      R
      <sub className={styles.sub}>w</sub>
      {SUFFIXES[rangeKey]}
      {withUnit && ` ${t(DICTIONARY.soundproofingPage.decibels)}`}
    </>
  );
}

export default RwLabel;
